/* Filled to sit at the same weight as CreditCardSVG beside it, and from remix-fill, which
   this component already uses for the selected check. */
import { Bank } from '@styled-icons/remix-fill/Bank';
import CreditCardSVG from 'components/CreditCardSVG';
import theme from 'styles/theme';

import * as S from './styles';

export type PaymentMethodTypes = {
  title: string;
  selected?: boolean;
  type: 'credit-card' | 'ach';
  onClick?: () => void;
};

const PaymentMethod = ({
  title,
  selected = false,
  type,
  onClick,
}: PaymentMethodTypes) => {
  const icon = {
    'credit-card': (
      <CreditCardSVG
        color={selected ? theme.colors.primary70 : theme.colors.neutralSilver60}
      />
    ),
    /* A bank, not the Plaid logo: Plaid is one way we link the account, not what the
       member is choosing. The same glyph marks ACH on the sign button of this step. */
    ach: (
      <Bank
        size={24}
        color={selected ? theme.colors.primary70 : theme.colors.neutralSilver60}
      />
    ),
  };

  return (
    <S.Wrapper selected={selected} onClick={onClick}>
      <S.Container>
        <S.PaymentIconWrapper>{icon[type]}</S.PaymentIconWrapper>
        {selected && (
          <S.CheckWrapper>
            <S.CheckIcon />
          </S.CheckWrapper>
        )}
      </S.Container>
      <S.Title>{title}</S.Title>
    </S.Wrapper>
  );
};

export default PaymentMethod;
